import React from 'react';
import i18n from '../../../i18n';

import { Icon } from 'components/Icon/Icon';
import { LargeButton, LargeButtonColor } from 'components/LargeButton/LargeButton';
import { Text, TextTypography } from 'components/Text/Text';

import { ReactComponent as PlusIcon } from 'assets/icons/main-16/plus--16.svg';

export const Category = () => {
    const { t } = i18n.useTranslation();
    return (
        <div>
            <LargeButton color={LargeButtonColor.TRANSPARENT}>
                <Icon component={PlusIcon} size={16} svgSize={16} />
                &nbsp;
                {t('onboarding:card.category.add')}
            </LargeButton>
            <div style={{ textAlign: 'center' }}>
                <Text typography={TextTypography.CAPTION}>{t('onboarding:card.category.description')}</Text>
            </div>
        </div>
    );
};
